/* ==========================================================
   DUPLICAÇÃO DE CARDS NA HOME - DESATIVADA
   Agora cada produto aparece apenas 1 vez na home.
   ========================================================== */
(function () {
  'use strict';
  // Script desativado intencionalmente.
  // Os cards da home vêm direto da collection "frontpage" do Shopify,
  // 1 card por produto cadastrado.
})();
